import { EventEmitter, Injectable } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";

@Injectable()
export class PageTitleService {
    
  private pageTitleSuffix: string = 'CAS';
  private pageTitlePrefix: string = null;
  private pageTitle: string = null;
  
  private fullPageTitle: string = null;


  constructor(
    private translator: TranslateService,
    private browserTitle: Title
  ){
    
  }


  
  public setPageTitle(key: string,
                      params: any = null) {
    
		this.translator.get('PAGE_TITLES.' + key+'.web',params).toPromise().then((webPageTitle) => {
			
			this.pageTitle = webPageTitle;
			this.updatePageTitle();
			
		});
		
  }
  
  public setPageTitlePrefix(prefix: string){
    if(prefix === '') prefix = null;
    this.pageTitlePrefix = prefix;
    this.updatePageTitle();
    
  }
  
  private updatePageTitle(){
    
    let newTitle =  this.pageTitle + ' • '+this.pageTitleSuffix;
		if(this.pageTitlePrefix !== null) newTitle = this.pageTitlePrefix + ' '+ newTitle;
    
    if(newTitle !== this.fullPageTitle){
      this.fullPageTitle = newTitle;
      this.browserTitle.setTitle(this.fullPageTitle);
    }
    
  }
  

}


// WEBPACK FOOTER //
// ./src/services/page-title.service.ts